// Shopify embedded app (pages shown inside the Shopify admin).
// Imported by vite.config.ts (build time) and by the app (run time), so it
// must stay free of browser-only imports.

// Every embedded route starts with this; the hosts serve shopify-admin.html
// for all of them (vite-plugins/shopifyEmbedded.ts locally, a CloudFront
// function when deployed).
export const SHOPIFY_EMBEDDED_BASE_PATH = '/embedded'
export const SHOPIFY_EMBEDDED_HTML_FILE = 'shopify-admin.html'
// Its build entry name (vite.config.ts rollupOptions.input).
export const SHOPIFY_EMBEDDED_ENTRY = 'shopifyAdmin'

// App Bridge always serves its latest version; Polaris is pinned on purpose
// (Shopify's guidance), so bump it together with any type changes.
export const SHOPIFY_APP_BRIDGE_SCRIPT_URL =
  'https://cdn.shopify.com/shopifycloud/app-bridge.js'
export const SHOPIFY_POLARIS_SCRIPT_URL =
  'https://cdn.shopify.com/shopifycloud/polaris-1.1.js'

// Origins allowed to frame the embedded pages (Content-Security-Policy
// frame-ancestors). The shop's own domain is added per request.
export const SHOPIFY_ADMIN_ORIGIN = 'https://admin.shopify.com'
export const SHOPIFY_SHOP_DOMAIN_PATTERN = /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/

// Client IDs of Zoko's Shopify apps: "Zoko - Test" for development, the live
// App Store app for production. The one source for both the dashboard
// (config.SHOPIFY_API_KEY) and the embedded page, which is now those same apps
// made embedded rather than a separate app.
export const SHOPIFY_APP_CLIENT_IDS = {
  development: '88e0abf447b53546e5891f8696d4ef38',
  production: 'a062193d60747a394630435afc6dfc74',
}

// Client ID the embedded page loads App Bridge with, per Vite mode; matches
// which config each mode spreads in lib/config/index.js.
export const SHOPIFY_EMBEDDED_API_KEYS: Record<string, string> = {
  development: SHOPIFY_APP_CLIENT_IDS.development,
  staging: SHOPIFY_APP_CLIENT_IDS.development,
  production: SHOPIFY_APP_CLIENT_IDS.production,
  staging_prod: SHOPIFY_APP_CLIENT_IDS.production,
  wicks: SHOPIFY_APP_CLIENT_IDS.production,
}

// Placeholders in shopify-admin.html, replaced at build/serve time.
export const SHOPIFY_EMBEDDED_HTML_TOKENS = {
  apiKey: '__SHOPIFY_API_KEY__',
  appBridgeUrl: '__SHOPIFY_APP_BRIDGE_URL__',
  polarisUrl: '__SHOPIFY_POLARIS_URL__',
}
